<template>
    <div class="rating p-1">
        <button-radio-group :options="mappedOptions" button-classes="outline"
            @change="changed" :value="value+''" :unselectable="true">
        </button-radio-group>
        
        <base-button type="primary" outline
            class="btn-icon-only rounded-circle d-inline"
            v-if="hasComment"
            @click="openComment"
        >
            <span class="btn-inner--icon"><i class="fas fa-edit"></i></span>
        </base-button>

        <!-- Don't return to the line here !-->
        <p class="description comment mb-0 mr-3 mt-2">{{ comment }}</p>

        <portal to="modals">

            <base-modal :value="commentModalValue" @input="commentModalValue.show = false"
                :title="title"
                :centered="false"
            >
                <form @submit.prevent="submit">
                    <base-input :label="$t('dashboard.comment')">
                        <textarea class="form-control"
                            :placeholder="$t('dashboard.enter-comment-here')"
                            rows="5"
                            :value="comment"
                            @input="commentChanged"
                        >
                        </textarea>
                    </base-input>

                    <div class="text-center">

                        <base-button type="primary" @click="submitComment">
                            {{ $t('common.save') }}
                        </base-button>
                    </div>

                </form>
            </base-modal>
            
        </portal>
    </div>
</template>

<script>
    export default {

        props: {

            title: {
                type: String,
                default: ''
            },

            value: {
                type: [Number, String],
                default: 0
            },

            options: {
                type: Array,
                required: true
            },

            hasComment: {
                type: Boolean,
                default: false
            },

            comment: {
                type: String,
                default: null
            },
        },

        data() {
            return {
                commentModalValue: { show: false },
                localComment: null,
            }
        },

        watch: {
            comment: {
                handler(newComment) {
                    this.localComment = newComment
                },
                immediate: true
            }
        },

        computed: {

            mappedOptions() {
                return this.options.map(option => {
                    return {
                        value: option.value + '',
                        label: option.name,
                        classes: 'btn-'+option.color+' btn-round mr-1',
                    }
                })
            }
        },

        methods: {
            changed(val) {
                this.$emit('input', val)
            },

            openComment() {
                this.commentModalValue.show = true
            },

            commentChanged(event) {
                this.localComment = event.target.value.replace(/^\s+|\s+$/g, '')
            },

            submitComment() {
                this.commentModalValue.show = false
                this.$emit('comment-change', this.localComment)
            }
        }
    }
</script>

<style scoped>

    .description {
        white-space: pre-wrap;
        font-size:12px;
        text-align: left;
    }
    .rating >>> label {
        min-height: 42px;
    }
    .rating >>> .btn-group-toggle {
        display: inline-block;
    }
    .rating >>> .base-button {
        border-color: white;
    }
    .rating >>> .base-button:hover {
        color: #233dd2;
        background-color: white;
        box-shadow: none;
        transform: none;
    }

</style>